import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Inicio from "./pages/Inicio";
import Convocatoria from "./pages/Convocatoria";
import Login from "./pages/Login";
import Registro from "./pages/Registro";
import Limpiador from "./pages/Limpiador";
import Personal from "./pages/Personal";
import Convenios from "./pages/Convenios";
import InicioProfesores from "./pages/InicioProfesores";
import BlogEntrada from "./pages/BlogEntrada";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

export default function AppRouter() {
  return (
    <Router basename="/">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/convocatoria" element={<Convocatoria />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Registro />} />
        <Route path="/personal" element={<Personal />} />
        <Route path="/convenios" element={<Convenios />} />

        {/* RUTAS PROTEGIDAS */}
        <Route element={<ProtectedRoute />}>
          <Route path="/limpiador" element={<Limpiador />} />
          <Route path="/inicio_profesores" element={<InicioProfesores />} />
          <Route path="/blog_entrada" element={<BlogEntrada />} />
        </Route>
      </Routes>
    </Router>
  );
}